<template>
  <div v-loading="loading">
    <card 
      :title="$t('pages.evse_picker.labels.location_info')"
      v-if="location !== undefined">
      <el-row class="mb-4">
        <el-col :xs="24" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.evse_picker.labels.id") }}
            <p>{{ location.locationId }}</p>
          </label>
        </el-col>
        <el-col v-if="location.name" :xs="24" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.evse_picker.labels.name") }}
            <p>{{ location.name }}</p>
          </label>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.evse_picker.labels.address") }}
            <p>{{ location.address }}</p>
          </label>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.evse_picker.labels.city") }}
            <p>{{ location.city }}</p>
          </label>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="md-3">
          <label class="input-label">
            {{ $t("pages.evse_picker.labels.country") }}
            <p>{{ location.country }}</p>
          </label>
        </el-col>
      </el-row>
    </card>
    <card v-if="!location" class="centered-content">
      <div>
        <p>{{ $t("pages.evse_picker.no_location") }}</p>
      </div>
    </card>
    <h4> {{ $t('pages.evse_picker.title') }} </h4>
    <el-row :gutter="25">
      <el-col :xs="24" :sm="24" :lg="24">
        <div v-for="row in tableData" :key="row.uid">
          <el-button class="button-evse" @click="onRowClick(row)" :round=true >
            <p style="white-space: pre-line" class="button-text-evse">{{ $t('pages.evse_picker.socket') + " " + parseInt(row.uid.slice(-1)) }}</p>
            <p style="white-space: pre-line" class="button-text-evse">{{
              $t("enum.connector-type." + row.connector_type)
            }}</p>
            <div v-if="row.physical_reference">
              <p class="button-text">
                {{ row.physical_reference }}
              </p>
            </div>
          </el-button>        
        </div>
      </el-col>
    </el-row>
    <div style="margin: 0 auto; text-align: center; padding-bottom: 15px">
      <el-button class="button" @click="goBack()" :round="true">
        {{ $t("pages.session_confirm.go_back").toUpperCase()   }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapActions, mapGetters, mapMutations } = createNamespacedHelpers("session");

export default {
  name: "EvsePicker",
  data() {
    return {
      tableData: [],
      loading : undefined,
      location: this.getLocation()
    };
  },
  created: function() {
    this.tableData = this.getEvses();
  },
  methods: {
    ...mapActions(["cancelPayment"]),
    ...mapMutations(["saveToken", "changeStatusToCreated"]),
    ...mapGetters(["getEvses", "getLocation", "getSessionStatus", "getCommandSent", "getPaymentId"]),
    async onRowClick(record) {
      this.loading = true;
      this.$store.commit("session/setEvseUid", record.uid);
      this.$store.commit("session/setTariff", record.tariff)
      this.loading = false
      this.$router.replace({
        name: "SessionConfirm",
        params: {
          from: {
            name: "EvsePicker",
            params: this.$route.params
          }
        }
      });
    },
    async goBack(){
      const status = this.getSessionStatus();
      if(
        status === "Authorized" || 
        (status === "Pending" && !this.getCommandSent())
      ){
        try {
          this.loading = true
          let response = await this.cancelPayment(this.getPaymentId());

          if (response.status === 200) {
            this.$store.commit("session/changeStatusToCreated"); 
            this.$message({
              type: "success",
              message: this.$t('pages.payment_checkout.payment_cancelled_success')
            });
          }
          this.loading = false
        } catch (error) {
          this.$console("error", error);
          this.$message({
            type: "error",
            message: this.$t('pages.payment_checkout.payment_cancelled_error')
          });
          this.loading = false
        }   
      }

      const params = {
        countryCode: this.location.countryCode,
        partyId: this.location.partyId,
        locationId: this.location.locationId,
        reload: false
      }
      this.$router.replace({
        name: "PaymentMethod",
        params
      });      
    },
  }
};
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700&display=swap');

.el-date-editor.el-input {
  width: 100%;
}
.button-evse{
  margin-bottom:8px;
  margin-top:8px;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  background-color: hsla(188, 60%, 60%, 0.10);
}
.button-text-evse{
  font-family: "Montserrat";
  color: #0F6A88;
  font-style: normal !important;
  font-weight: 400 !important;
  font-display: swap !important;
}
.center {
  display: flex;
  justify-content: center;
  align-items: center;
}
h4 {
  font-family: "Montserrat";
  font-style: normal !important;
  font-weight: 700 !important;
  font-display: swap !important;
  color: #026A89 !important;
  text-align :center !important;
}
</style>
